import { COMPONENT_LIBRARY } from './componentLibrary.ts';
import type { ComponentDef } from './componentLibrary.ts';

export class ComponentsPanel {
  private container: HTMLElement;
  private onComponentClick: (comp: ComponentDef) => void;

  constructor(containerId: string, onComponentClick: (comp: ComponentDef) => void) {
    this.container = document.getElementById(containerId)!;
    this.onComponentClick = onComponentClick;
    this.render();
  }

  private render(): void {
    this.container.innerHTML = '';

    for (const category of COMPONENT_LIBRARY) {
      const section = document.createElement('div');
      section.className = 'component-category';

      const title = document.createElement('div');
      title.className = 'component-category-title';
      title.textContent = category.name;
      section.appendChild(title);

      const grid = document.createElement('div');
      grid.className = 'component-grid';

      for (const comp of category.items) {
        grid.appendChild(this.createChip(comp));
      }

      section.appendChild(grid);
      this.container.appendChild(section);
    }
  }

  private createChip(comp: ComponentDef): HTMLElement {
    const chip = document.createElement('div');
    chip.className = 'component-chip';
    chip.draggable = true;
    chip.title = comp.description;
    chip.innerHTML = `
      <span class="component-chip-emoji">${comp.emoji}</span>
      <span class="component-chip-label">${comp.label}</span>
    `;

    chip.addEventListener('dragstart', (e) => {
      e.dataTransfer!.setData('application/component', JSON.stringify(comp));
      e.dataTransfer!.effectAllowed = 'copy';
      chip.classList.add('dragging');
    });

    chip.addEventListener('dragend', () => chip.classList.remove('dragging'));

    chip.addEventListener('click', () => this.onComponentClick(comp));

    return chip;
  }
}
